<template>
	<div class="bg">
		<div class="head flex-between-center">
			<img src="@/assets/image/login_logo.png" alt="" @click="navigateTo('/login')">
			<div v-if="publicConfig" class="tel">咨询热线：{{publicConfig.business_phone}}</div>
		</div>

		<div class="main flex-column flex-between-center">
			<div class="title">填写以下信息马上为您开通免费版</div>

			<c-form ref="form" class="form">
				<div class="item flex-center">
					<label><b>*</b>您的姓名</label>
					<c-input class="flex-grow" type="text" name="saas_contact_person" placeholder="怎么称呼您？" :clear="false"></c-input>
				</div>
				<div class="item flex-center">
					<label><b>*</b>公司名称</label>
					<c-input class="flex-grow" type="text" name="saas_name" :clear="false"></c-input>
				</div>
				<div class="item flex-center">
					<label><b>*</b>手机号码</label>
					<c-input v-model="phone" class="flex-grow" type="text" name="phone" placeholder="11位手机号码" :clear="false"></c-input>
				</div>
				<div class="item flex-center">
					<label><b>*</b>短信验证码</label>
					<c-input class="flex-grow" type="text" name="verify_code" maxlength="4" :clear="false">
						<template #append>
							<a class="smscode" :class="{'z-dis': !!countdown}" @click="getSmscode">{{countdownText}}</a>
						</template>
					</c-input>
				</div>
				<c-checkbox v-model="agreement">我已阅读并同意<c-link color="main" @click.native.stop="$refs.agreement.open()">《蜂鸟工单软件服务条款》</c-link></c-checkbox>
			</c-form>

			<c-button class="button" size="form" color="main" @click="submit">立即开通</c-button>
		</div>

		<p class="copyright">版权所有©2023-{{new Date().getFullYear()}} 蜂鸟生产工单</p>

		<c-dialog ref="agreement" width="750" height="500" title="蜂鸟工单软件服务条款" button-name="同意以上协议" :cancel-button="false" @resolve="agreement = true">
			<div v-if="publicConfig" v-html="publicConfig.free_regist_agreement" class="agreement"></div>
		</c-dialog>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		data() {
			return {
				phone: '',
				countdown: false,
				agreement: false
			}
		},

		computed: {
			...mapState(['publicConfig']),

			countdownText() {
				return this.countdown ? `(${this.countdown})` : this.countdown === 0 ? '重新获取' : '获取验证码';
			}
		},

		beforeDestroy() {
			clearTimeout(this._timer);
		},

		methods: {
			getSmscode() {
				if (this.countdown) return;
				if (!this.phone) {
					this.$message({
						message: '请输入手机号'
					});
					return;
				}
				this.request({
					url: '/register/verify/code',
					data: {
						client: 0,
						phone: this.phone
					},
					loading: true,
					success: () => {
						this.$message({
							message: '验证码已发送'
						});
						!function loop(s) {
							this.countdown = s;
							if (s == 0) return;
							this._timer = setTimeout(() => {
								loop.call(this, --s);
							}, 1000);
						}.call(this, 60);
					}
				});
			},

			submit() {
				this.$refs.form.validate({
					breakWhenFail: true,
					rule: {
						saas_contact_person: '请输入姓名',
						saas_name: '请输入公司名称',
						phone: [{
							type: 'empty',
							message: '请输入手机号'
						}, {
							type: 'regexp',
							regexp: ['phone'],
							message: '手机号码格式错误'
						}],
						verify_code: [{
							type: 'empty',
							message: '请输入短信验证码'
						}, {
							type: 'function',
							message: '请先获取验证码',
							fun: () => {
								return this.countdown !== false;
							}
						}]
					},
					success: () => {
						if (!this.agreement) {
							this.$message({
								message: '请阅读并同意《蜂鸟工单软件服务条款》'
							});
							return;
						}
						
						this.$refs.form.submit({
							url: '/register/verify/code/check',
							dataFormatter: data => {
								data.client = 0;
								return data;
							},
							success: (data, res) => {
								this.$store.dispatch('setLoginInfo', res);
								this.redirectTo('/');
							},
							fail: (data, code) => {
								clearTimeout(this._timer);
								this.countdown = 0;
								if (code == 9300) {
									this.$confirm({
										message: '当前手机号已注册，是否前往登录？',
										buttonName: '前往登录',
										resolve: () => {
											this.navigateTo('/login');
										}
									})
									return false;
								}
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.bg {
		position: relative;
		height: 100vh;
		overflow: hidden;
		background-image: url('~@/assets/image/register_bg.jpg');
		background-size: cover;
	}
		
	.head {
		box-sizing: border-box;
		width: 100%;
		height: 90px;
		border-bottom: 1px solid #D5DFDA;
		padding: 0 30px 0 50px;
		
		img {
			height: 45px;
			cursor: pointer;
		}

		.tel {
			border-radius: 20px;
			padding: 0 18px;
			line-height: 40px;
			font-size: 16px;
			color: #fff;
			background: var(--color-main);
		}
	}

	.main {
		position: fixed;
		top: 50%;
		left: 50%;
		width: 500px;
		border-radius: 10px;
		overflow: hidden;
		background: #fff;
		transform: translate(-50%,-50%);
			
		.title {
			width: 100%;
			line-height: 90px;
			font-size: 22px;
			text-align: center;
			color: #fff;
			background-image: url('~@/assets/image/register_top.jpg');
			background-size: cover;
		}
		
		.form {
			box-sizing: border-box;
			width: 100%;
			padding: 40px 50px 0;
			
			.item {
				width: 100%;
				height: 42px;
				border: 1px solid #ddd;
				border-radius: 4px;

				label {
					min-width: 80px;
					margin: 0 12px;
					font-size: 14px;
					white-space: nowrap;
					color: #666;

					b {
						margin-right: .5em;
						color: #f00;
					}
				}

				>>> .c-input {
					border: none;
					box-shadow: none;
				}

				.smscode {
					display: block;
					margin-top: 9px;
					margin-right: 8px;
					line-height: 20px;
					font-size: 12px;
					color: var(--color-main);

					&.z-dis {
						color: #999;
					}
				}
			}
		}
		
		.button {
			width: 400px;
			height: 50px !important;
			border-radius: 2px;
			margin: 22px 0 42px;
			font-size: 18px;
		}
	}
		
	.copyright {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		line-height: 60px;
		font-size: 12px;
		text-align: center;
		color: #999;
	}

	.agreement {
		padding: 20px 30px;
		line-height: 2;
		font-size: 14px;
		color: #333;
	}
</style>
